export default __webpack_public_path__ + "static/creative_buzz_badge-fc3415cc2eb99cb671b6c2da18e73c01.svg";